import { CargoList } from 'components/cargos/cargo-create-with-order/components/cargo-list';
import { OrderForm } from 'components/orders/order-form';
import { OrderFormConclusion } from 'components/orders/order-form/components/order-form-conclusion';
import type { IOrderFormWithCargoListProps } from './types';

export const OrderFormWithCargoList = (props: IOrderFormWithCargoListProps) => {
  const { cargos, handleOpenCargoForm, onDeleteCargo, onEditCargo, ...orderFormProps } = props;

  return (
    <div>
      <OrderForm
        {...orderFormProps}
        footerRender={(client, contact) => (
          <>
            <CargoList
              cargos={cargos}
              handleOpenCargoForm={handleOpenCargoForm}
              onDeleteCargo={onDeleteCargo}
              onEditCargo={onEditCargo}
            />
            <OrderFormConclusion client={client} contact={contact} />
          </>
        )}
      />
    </div>
  );
};
